import { NextPageContext } from 'next';
import * as Sentry from '@sentry/nextjs';
import { ErrorPage } from '~/page-components/Layout';

function ServerErrorPage({ statusCode }: { statusCode: number }) {
   return <ErrorPage error={{ code: statusCode }} />;
}

ServerErrorPage.getInitialProps = async (context: NextPageContext) => {
   // In case this is running in a serverless function, await this in order to give Sentry
   // time to send the error before the lambda exits
   await Sentry.captureUnderscoreErrorException(context);

   const { res, err } = context;
   const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
   return { statusCode };
};

export default ServerErrorPage;
